import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.marion-materiaux.com/api";
//const API_BASE_URL = process.env.REACT_APP_API_URL || "https://recette.api.marion-materiaux.com/api";
//const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api";

const instance = axios.create({
  baseURL: API_BASE_URL,
});

// Intercepteur pour ajouter le token
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur pour gérer les erreurs 401 et 429
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Gérer l'erreur 401 (non autorisé)
    if (error.response?.status === 401) {
      // Only clear auth data, not all localStorage
      localStorage.removeItem("authToken");
      localStorage.removeItem("userData");
      window.location.href = "/login";
      return Promise.reject(error);
    }

    // Gérer l'erreur 429 (trop de requêtes)
    if (error.response?.status === 429) {
      // Initialiser le compteur de retry
      if (!originalRequest._retryCount) {
        originalRequest._retryCount = 0;
      }

      // Limiter à 3 tentatives
      if (originalRequest._retryCount < 3) {
        originalRequest._retryCount++;

        // Attendre avant de réessayer (exponential backoff)
        const retryAfter = error.response.headers['retry-after']
          ? parseInt(error.response.headers['retry-after']) * 1000
          : Math.min(1000 * Math.pow(2, originalRequest._retryCount), 10000); // 2s, 4s, 8s max

        console.log(`⚠️ Rate limit atteint. Tentative ${originalRequest._retryCount}/3 dans ${retryAfter / 1000}s...`);

        await new Promise(resolve => setTimeout(resolve, retryAfter));

        return instance(originalRequest);
      }

      console.error('❌ Trop de tentatives après rate limit. Abandon.');
    }

    return Promise.reject(error);
  }
);

// Clé Google Maps
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyCoMoDDmlBQA3i8TOLYp4_NBVBrSr8Dj-c";

// Fonction pour calculer la durée de trajet depuis le backend
export const getTravelTimeFromBackend = async (origin, destination, departureTime) => {
  try {
    const response = await instance.post("/calculate-duration", {
      origin: `${origin.lat},${origin.lng}`,
      destination: `${destination.lat},${destination.lng}`,
      departure_time: Math.floor(new Date(departureTime).getTime() / 1000),
    });

    if (response.data && response.data.success) {
      console.log("calculate-duration :", response.data.duration_in_minutes);
      return response.data.duration_in_minutes;
    }
    return null;
  } catch (error) {
    console.error("Erreur lors de l'appel à /calculate-duration :", error);
    return null;
  }
};

// Fonction pour calculer le prix côté backend (sécurisé)
export const calculatePriceFromBackend = async (idFournisseur, poids, estimatedTime, livraisonType) => {
  try {
    const response = await instance.post("/fo/calculate-price", {
      id_fournisseur: idFournisseur,
      poids,
      estimatedTime,
      livraisonType,
    });

    if (response.data && response.data.success) {
      console.log("💰 Prix calculé depuis le backend :", response.data.data);
      return response.data.data;
    }
    return null;
  } catch (error) {
    console.error("❌ Erreur lors du calcul de prix :", error);
    return null;
  }
};

export default instance;
